const GA_MEASUREMENT_ID = 'G-BM53MV8KXD';

const sanitizeParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

export const trackPageView = ({ pagePath, pageTitle, pageLocation } = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, sanitizeParams({
    page_path: pagePath,
    page_title: pageTitle,
    page_location: pageLocation
  }));
};

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function' || !eventName) {
    return;
  }

  window.gtag('event', eventName, sanitizeParams(params));
};

export const trackEventOnce = (storageKey, eventName, params = {}) => {
  if (!storageKey) {
    trackEvent(eventName, params);
    return;
  }

  if (typeof window === 'undefined') {
    return;
  }

  const sessionKey = `ga_once:${storageKey}`;
  if (window.sessionStorage.getItem(sessionKey) === '1') {
    return;
  }

  trackEvent(eventName, params);
  window.sessionStorage.setItem(sessionKey, '1');
};

export { GA_MEASUREMENT_ID };
